var _div;
// This file contains commented code that will be implemented later. DO NOT DELETE, pls

import LockCircle from '@crehana/compass.icons.fill/LockCircle';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Clamp } from '@crehana/ui';
import cn from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SubMenuDesktopLink = function SubMenuDesktopLink(_ref) {
  var label = _ref.label,
    isLocked = _ref.isLocked,
    _ref$decorationType = _ref.decorationType,
    decorationType = _ref$decorationType === void 0 ? 'left-line' : _ref$decorationType,
    isSelectedURL = _ref.isSelectedURL,
    onClickItem = _ref.onClickItem;
  var isLeftLine = decorationType === 'left-line';

  // TODO: This could be implemented later, when the men is integrated at the LAYOUTS library
  // useEffect(() => {
  //   if (onSelectedChange) {
  //     onSelectedChange(isSelectedURL);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isSelectedURL]);

  // const handleLinkItem = () => {
  //   onClickItem && onClickItem(url || '');
  // };

  return /*#__PURE__*/_jsx("li", {
    className: cn('tw-font-subtitle5', {
      'tw-ml-3.2 my-8 tw-mr-1.2': isLeftLine
    }),
    children: /*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: onClickItem,
      className: cn('tw-flex tw-items-center tw-w-full tw-h-3.6 tw-px-1.2 tw-text-left tw-rounded-[5px] tw-relative tw-z-2', isSelectedURL ? 'tw-bg-neutral-dark-200 tw-text-primary-light-500' : 'tw-text-neutral-light-700 hover:tw-text-primary-light-500 hover:tw-bg-neutral-light-200',
      // Dark theme
      'dark:tw-text-neutral-dark-400 dark:hover:tw-text-secondary-dark-300 dark:hover:tw-bg-neutral-dark-700'),
      children: [isLeftLine && (_div || (_div = /*#__PURE__*/_jsx("div", {
        className: "tw-absolute -tw-top-[2.8rem] -tw-left-1.2 tw-z-1 tw-w-[20px] tw-h-4.8 tw-bg-transparent tw-border-l-[2px] tw-border-b-[2px] tw-border-solid tw-rounded-[5px] dark:tw-border-elevation-dark-04 tw-border-neutral-light-300 tw-rounded-br-0 "
      }))), /*#__PURE__*/_jsx(Clamp, {
        clamp: 1,
        children: label
      }), isLocked && /*#__PURE__*/_jsx(LockCircle, {
        size: 20,
        className: cn('tw-ml-auto tw-text-neutral-dark-400', isSelectedURL && 'tw-text-primary-light-300')
      })]
    })
  });
};
export default SubMenuDesktopLink;